import types from '../../../actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'

export const contactsContextDocumentsTabPivotTableKey = 'contactsContext.selected.documentsTab.pivotTable'

const folders = (state = [], action) => {
  switch (action.type) {
    case types.CONTACTS_DETAILS_CONTACT_LOAD_ATTEMPT:
    case types.CONTACTS_DETAILS_COMPANY_LOAD_ATTEMPT:
      return []
    case types.CONTACTS_DOCUMENTS_ADD_FOLDER:
      return [
        ...state,
        action.folder,
      ]
    case types.CONTACTS_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return [action.folder]
    case types.CONTACTS_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX:
      return state.slice(0, action.index)
    default:
      return state
  }
}

const rootFolder = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_DETAILS_CONTACT_LOAD_ATTEMPT:
    case types.CONTACTS_DETAILS_COMPANY_LOAD_ATTEMPT:
      return null
    case types.CONTACTS_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return action.folder
    default:
      return state
  }
}

const currentFolder = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_DETAILS_CONTACT_LOAD_ATTEMPT:
    case types.CONTACTS_DETAILS_COMPANY_LOAD_ATTEMPT:
      return null
    case types.CONTACTS_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
    case types.CONTACTS_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS:
    case types.CONTACTS_DOCUMENTS_ADD_FOLDER:
      return action.folder
    default:
      return state
  }
}

const subFolder = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_DOCUMENTS_SET_SELECTED_SUB_FOLDER:
      return action.path
    default:
      return state
  }
}

export default combineReducers({
  folders,
  rootFolder,
  currentFolder,
  subFolder,
  pivotTable: createPivotTableReducer({key: contactsContextDocumentsTabPivotTableKey, defaultSortColumn: 'folderName'}),
})
